import { numberlookup } from "../constants";
import { Buffer } from "buffer";

export const replaceCountryCode = (phone) => {
  const regex = /(\+91)/g;
  const result = phone?.replace(regex, "");
  return result;
};

export const getAvatarName = (name) => {
  const matches = name.match(/\b(\w)/g);
  return matches ? matches?.join("") : "";
};

export const showLoadingOverlay = (text = "Loading") => {
  const target = document.getElementById("full-screen-loader");
  if (target) {
    // if (document.getElementById('loading-text')) document.getElementById('loading-text').innerText = text;
    target.classList.remove("hidden");
    target.classList.add("flex");
  }
};

export const hideLoadingOverlay = () => {
  const target = document.getElementById("full-screen-loader");
  if (target) {
    target.classList.add("hidden");
    target.classList.remove("flex");
  }
};

export const getYoutubeVideoId = (url) => {
  if (!url) return "";
  const regExp =
    /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  const videoId = match && match[2].length === 11 ? match[2] : "";
  return videoId;
};

export const getYoutubeVideoThumbnail = (url) => {
  const videoId = getYoutubeVideoId(url);
  const thumbnail = `https://img.youtube.com/vi/${videoId}/0.jpg`;
  return thumbnail;
};

export const deepCopy = (data) => {
  return JSON.parse(JSON.stringify(data));
};

export const formatCurrency = (amount) => {
  if (!amount || isNaN(amount)) {
    return "0.00"; // Default value or error handling
  }

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "INR", // Change the currency code as needed
  });

  return formatter.format(parseFloat(amount));
};

export const parseNumber = (value) => {
  if (!value) {
    return 0; // Return NaN for invalid input or non-string values
  }
  // Remove non-numeric characters and parse the string to a float
  const numericValue = parseFloat(value.replace(/[^0-9.-]/g, ""));

  return !isNaN(numericValue) ? numericValue : 0;
};

export const isValidJson = (data) => {
  try {
    JSON.parse(data);
    return true;
  } catch (err) {
    return false;
  }
};

export const shuffleList = (list) => {
  let currentIndex = list.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [list[currentIndex], list[randomIndex]] = [
      list[randomIndex],
      list[currentIndex],
    ];
  }

  return list;
};

export const currentYear = new Date().getFullYear();

export const getYearOptions = (min = 1950, max = currentYear) => {
  const data = [];

  for (let year = max; year >= min; year--) {
    data.push({ label: `${year}`, value: `${year}` });
  }

  return data;
};

export const nFormatter = (num, digits = 2) => {
  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
  const item = numberlookup.findLast((item) => num >= item.value);
  return item
    ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol)
    : "0";
};

export const trimsToParticularLength = (data, len) => {
  if (!data) return "";
  if (data?.length > len) {
    return data.slice(0, len - 2) + "...";
  }
  return data;
};

export const isYoutubeLink = (url) => {
  const regExp =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  return regExp.test(url);
};

export const formatNumberInString = (num) => {
  if (num <= 999) return `${num}`;
  else if (num > 999 && num < 99999) {
    const finalNum = num / 1000;
    return `${finalNum.toFixed()}K`;
  } else if (num > 99999 && num < 9999999) {
    const finalNum = num / 100000;
    return `${finalNum.toFixed()}Lac`;
  } else {
    const finalNum = num / 10000000;
    return `${finalNum.toFixed()}Cr`;
  }
};

export const dataURLtoFile = (dataurl) => {
  const filename = `IMG-${new Date().valueOf()}`;
  let arr = dataurl?.split(","),
    mime = arr[0]?.match(/:(.*?);/)[1],
    bstr = atob(arr[arr?.length - 1]),
    n = bstr?.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr?.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const FormatLocation = (location) => {
  try {
    const parsedLocation = isValidJson(location)
      ? JSON.parse(location)?.[0]?.split?.(",")?.[0] ?? ""
      : location?.split(",")?.[0];
    return parsedLocation;
  } catch (err) {
    return "";
  }
};

export function formatMinutes(minutes) {
  return minutes < 10 ? `0${minutes}` : `${minutes}`;
}

export function formatSeconds(seconds) {
  return seconds < 10 ? `0${seconds}` : `${seconds}`;
}

export function encodeData(data) {
  return btoa(JSON.stringify(data));
}

export function decodeData(data) {
  const cleanedString = unescape(decodeURIComponent(data));
  return JSON.parse(Buffer.from(cleanedString, "base64").toString("utf-8"));
}

export const handleUploadAudio = (successCallback) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "audio/*";
  input.multiple = true;

  input.onchange = async (event) => {
    const files = Array.from(event.target.files);

    successCallback(files);
  };

  input.click();
};

export const handleUploadPdf = (successCallback) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "application/pdf";

  input.onchange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      console.log("No file selected.");
      return;
    }

    successCallback(file);
  };

  input.click();
};
